export default __webpack_public_path__ + "static/media/LineosoftMenuAndSettings (2)-min.f13f41d0.PNG";